import { Button } from "@/components/primitives/button";

import { useNavigationState } from "@/zustand/NavigationState";
import {
  ChevronLeft,
  // MessageSquareQuote
} from "lucide-react";

import { useTranslation } from "react-i18next";

import { useActiveThread } from "./messages/hooks/useActiveThread";

export default function ThreadPlaygroundHeader() {
  const { t } = useTranslation();

  // global state references

  const activeThreadId = useNavigationState((state) => state.activeThreadId);
  const setActiveThreadId = useNavigationState(
    (state) => state.setActiveThreadId,
  );

  const activeThread = useActiveThread();

  if (!activeThreadId) {
    return null;
  }

  return (
    <>
      {/* eslint-disable-next-line */}
      <div className="flex h-middleColumnHeaderHeight items-center border-b border-primary/20 px-4 align-middle lg:px-6">
        {/* NAVIGATE BACK FROM THREAD VIEW */}
        <Button
          className="mr-2"
          size="icon"
          variant="ghost"
          onClick={() => setActiveThreadId(null)}
        >
          <ChevronLeft />
        </Button>

        <div className="ml-2 flex flex-col gap-0 truncate align-middle">
          <h2 className="truncate text-lg font-semibold leading-tight">
            {t("threads.thread")}
          </h2>
          <h3 className="text-md truncate font-normal leading-tight">
            {activeThread?.sender}
          </h3>
        </div>

        {/* <div className="ml-auto flex items-center gap-7">
          <Button
            asChild
            className="size-5 cursor-pointer"
            size="icon"
            variant="ghost"
            disabled
          >
            <MessageSquareQuote
              className="shrink-0 border-none outline-none"
              size={20}
              strokeWidth={2}
            />
          </Button>
        </div> */}
      </div>
    </>
  );
}
